import React, { ReactNode } from 'react';
import { TblViewSpec } from './table-view.types';
import { TblFltStats } from './table.types';
import TableTopControls from './TableTopControls';

export type TblTopParams = {
    id: string;
    fltStats?: TblFltStats;
    views?: TblViewSpec[];
    currrentViewId?: string;
    topRight?: ReactNode;
    cssName?: string;
    children?: ReactNode;
    alternateTitleLeft?: string;
    noSpacingTop?: boolean;
};

const TableTop = ({
    id,
    fltStats,
    views,
    currrentViewId,
    topRight,
    cssName,
    children,
    alternateTitleLeft,
    noSpacingTop,
}: TblTopParams): JSX.Element => {
    return (
        <>
            {alternateTitleLeft ? <span>{alternateTitleLeft}</span> : null}
            <div
                id={id}
                className={`table-list-title ${cssName ?? ''}${noSpacingTop ? ' no-spacing-top' : ''}`}
            >
                {alternateTitleLeft ? null : (
                    <div className="title-left">
                        <TableTopControls
                            id={`${id} tblTopControls`}
                            fltStats={fltStats}
                            views={views}
                            currentViewId={currrentViewId}
                        />
                    </div>
                )}
                {topRight ? <div className="title-right">{topRight}</div> : null}
                {children}
            </div>
        </>
    );
};

export default React.memo(TableTop);
